import { render, staticRenderFns } from "./EventsSearch.vue?vue&type=template&id=c6e4c042"
import script from "./EventsSearch.vue?vue&type=script&lang=js"
export * from "./EventsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports